module.exports = __webpack_public_path__ + "media/assets/illustrations/welcome-image-mobile-5a2a5e6d4c4e0a00a2ae3d4fafb9791a.png";